import { checkFoodpandaActCycle } from '../views/home/foodpanda-share/business/check-act-cycle';
import { checkVitasoyActNotStart } from '../views/home/vitasoy-lottery-module/business/check-act-not-start';

type HomeShowFuncReturn = {
  /** 是否继续Home页面的执行 */
  isContinue: boolean;
  [key: string]: any;
};

/** 钩子函数的配置 */
export type HomeShowConfigItem = {
  /** 商户merchantId 或 spId至少配置一个, 优先使用spId */
  merchantId?: string;
  spId?: string;
  /** 该商户自定义钩子函数 */
  func: (config: HomeShowConfigItem, tools: any) => Promise<HomeShowFuncReturn>;
};

/**
 * beforeHomeShow的钩子配置
 * 根据merchantId或spId（优先使用spId）进行匹配对应的钩子函数
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const beforeHomeShowConfig: HomeShowConfigItem[] = [
  {
    merchantId: 'foodpanda',
    func: async () => {
      const { isContinue } = await checkFoodpandaActCycle();
      return { isContinue };
    },
  },
  {
    spId: 'Vitasoy',
    func: async () => {
      const { isContinue } = await checkVitasoyActNotStart();
      return { isContinue };
    },
  },
];
